import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import bannerbg from "../../assets/images/backgrounds/page-header-bg.jpg";
import { getMyBookings, cancelBooking } from "../../services/bookingService";

const statusLabel = {
  pending: "পেমেন্টের অপেক্ষায়",
  confirmed: "কনফার্মড",
  cancelled: "বাতিল",
};

const MyBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    getMyBookings()
      .then((data) => setBookings(data.data || []))
      .catch(() => setError("বুকিং লোড করা যায়নি।"))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleCancel = async (booking) => {
    if (!window.confirm("এই বুকিং বাতিল করতে চান?")) return;
    await cancelBooking(booking.booking_reference);
    load();
  };

  return (
    <React.Fragment>
      <Header parentMenu="my-bookings" activeMenu="/my-bookings" />
      <SiteBreadcrumb pageTitle="My Bookings" pageName="My Bookings" breadcrumbsImg={bannerbg} />

      <section style={{ padding: "80px 0" }}>
        <div className="container">
          {loading && <p>লোড হচ্ছে...</p>}
          {error && <p style={{ color: "#e6394f" }}>{error}</p>}
          {!loading && !error && bookings.length === 0 && (
            <p>
              এখনো কোনো বুকিং নেই। <Link to="/events">Event ব্রাউজ করুন</Link>
            </p>
          )}

          {bookings.map((b) => (
            <div
              key={b.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 12,
                padding: "20px",
                marginBottom: 16,
                border: "1px solid #eee",
                borderRadius: 8,
              }}
            >
              <div>
                <h4 style={{ margin: "0 0 6px" }}>{b.event?.title}</h4>
                <p style={{ margin: 0, color: "#666" }}>
                  {b.booking_reference} · {b.quantity} টিকেট · ৳{b.total_price} ·{" "}
                  <strong>{statusLabel[b.status] || b.status}</strong>
                </p>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                {b.status === "pending" && (
                  <>
                    <Link to={`/payment/${b.booking_reference}`} className="thm-btn">
                      পেমেন্ট করুন
                    </Link>
                    <button onClick={() => handleCancel(b)} className="thm-btn" style={{ background: "#eee", color: "#333" }}>
                      বাতিল করুন
                    </button>
                  </>
                )}
                {b.status === "confirmed" && (
                  <Link to={`/my-tickets/${b.booking_reference}`} className="thm-btn">
                    টিকেট দেখুন
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </React.Fragment>
  );
};

export default MyBookings;
